import { render, staticRenderFns } from "./EmailAccount.vue?vue&type=template&id=6e0bc748&scoped=true"
import script from "./EmailAccount.vue?vue&type=script&lang=js"
export * from "./EmailAccount.vue?vue&type=script&lang=js"
import style0 from "./EmailAccount.vue?vue&type=style&index=0&id=6e0bc748&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0bc748",
  null
  
)

export default component.exports